module.exports = __webpack_public_path__ + "static/media/canalLogo.88c721e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/canalLogo.png
// module id = 762
// module chunks = 0